import { render, staticRenderFns } from "./AgeSlider.vue?vue&type=template&id=2c847e7a&scoped=true"
import script from "./AgeSlider.vue?vue&type=script&lang=js"
export * from "./AgeSlider.vue?vue&type=script&lang=js"
import style0 from "./AgeSlider.vue?vue&type=style&index=0&id=2c847e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c847e7a",
  null
  
)

export default component.exports